import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import SingleSignOnFailedForm from '../../containers/Login/SingleSignOnFailedForm';
import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';


class SingleSignOnFailedPage extends Component {
  UNSAFE_componentWillMount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  }

  render() {
    return (
      <div>
        <SingleSignOnFailedForm />
      </div>
    );
  }
}

SingleSignOnFailedPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  token: state.token,
  location: ownProps.location,
});

export default connect(mapStateToProps)(SingleSignOnFailedPage);